<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button type="button" (click)="backToPage()" title="Back">
        <ion-icon name="chevron-back-outline"></ion-icon>&nbsp;Back
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ion-icon name="alert"></ion-icon>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button type="button" (click)="nextPage()" title="Next">
        Next&nbsp;<ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" #content>
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop"><ion-label class="banner-title">Risk Information</ion-label></ion-col>
    </ion-row>
  </ion-grid>
  <form [formGroup]="riskQuestionaryForm" class="form form-input margin-top-1rem">
    <ng-container formArrayName="riskQuestionary">
      <ion-card *ngFor="let riskQAFrm of riskQuestionary.controls; let idx = index" [formGroupName]="idx"
        class="view-mode">
        <ion-card-header>
          <ion-grid class="myChecklist">
            <ion-row>
              <ion-col>
                <ion-card-title *ngIf="riskQAFrm.get('questionType')?.value" class="transparent-background">
                  <h1>{{riskQAFrm.get('questionType')?.value}}</h1>
                </ion-card-title>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-header>
        <ion-card-content>
          <ion-list>
            <ion-item>
              <ion-label class="item-title" [innerText]="riskQAFrm.get('question')?.value"></ion-label>
              <ion-radio-group value="end" formControlName="questionResponse" id="questionResponse_{{idx}}">
                <ion-radio justify="end" value="Yes" [disabled]="accessibleMode==='VIEW'">Yes</ion-radio>
                <ion-radio justify="end" value="No" [disabled]="accessibleMode==='VIEW'">No</ion-radio>
              </ion-radio-group>
            </ion-item>
            <ion-item *ngIf="riskQAFrm.get('questionResponse')?.invalid && riskQAFrm.get('questionResponse')?.touched">
              <ion-text color="danger">Answer is required</ion-text>
            </ion-item>
            <ion-item class="ion-item">
              <ion-textarea labelPlacement="left"
                placeholder=" Please Enter Comment" formControlName="questionSupportInfo" id="questionSupportInfo_{{idx}}"
                name="questionSupportInfo" maxlength="500">
                <div slot="label">Comment :&nbsp;</div>
              </ion-textarea>
            </ion-item>
            <ion-item *ngIf="(riskQAFrm.get('questionResponse')?.value ==='No' && !riskQAFrm.get('questionSupportInfo')?.value)">
              <ion-text color="danger">Comment is required</ion-text>             
            </ion-item>
            <ion-item *ngIf="riskQAFrm.get('questionSupportInfo')?.hasError('pattern')">
              <ion-text color="danger">Special characters are not allowed</ion-text>
            </ion-item>
            <ion-item>
              <div class="risk-image-container">
                <div class="image-container">
                  <ion-icon *ngIf="accessibleMode!='VIEW'" class="spacing" name="camera" size="large" (click)="takePictureCompressed(idx)" ></ion-icon>
                  <ion-icon *ngIf="riskQAFrm.get('questionImage')?.value && accessibleMode!='VIEW'" class="spacing bg-danger" name="trash-outline" size="large" (click)="removePicture(idx)" ></ion-icon>
                  <br>
                  <div class="question-image-container">
                    <img class="question-image-view" [id]="idx" *ngIf="riskQAFrm.get('questionImage')?.value" [src]="riskQAFrm.get('questionImage')?.value">
                  </div>
                </div>
                <div class="image-container">
                  <ion-icon *ngIf="accessibleMode!='VIEW' && riskQAFrm.get('questionImage')?.value" class="spacing" name="camera" size="large" (click)="takePictureCompressed2(idx)" ></ion-icon>
                  <ion-icon *ngIf="riskQAFrm.get('questionImage2')?.value && accessibleMode!='VIEW'" class="spacing bg-danger" name="trash-outline" size="large" (click)="removePicture2(idx)" ></ion-icon>
                  <br>
                  <div class="question-image-container">
                    <img class="question-image-view" [id]="idx" *ngIf="riskQAFrm.get('questionImage2')?.value" [src]="riskQAFrm.get('questionImage2')?.value">
                  </div>
                </div>
              </div>
            </ion-item>
            
          </ion-list>

        </ion-card-content>
      </ion-card>
    </ng-container>
  </form>
  <div class="div">&nbsp;</div>
</ion-content>